var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.741 16.0081L12.7438 2.01305C12.5694 1.70536 12.3166 1.44944 12.011 1.27138C11.7054 1.09332 11.3581 0.999512 11.0044 0.999512C10.6508 0.999512 10.3034 1.09332 9.99788 1.27138C9.6923 1.44944 9.43943 1.70536 9.26506 2.01305L1.2679 16.0081C1.09165 16.3133 0.999224 16.6597 1 17.0122C1.00079 17.3647 1.09474 17.7107 1.27235 18.0152C1.44995 18.3197 1.70489 18.5718 2.01133 18.7459C2.31777 18.9201 2.66481 19.0102 3.01728 19.007H19.0116C19.3624 19.0067 19.7069 18.914 20.0105 18.7384C20.3142 18.5628 20.5663 18.3103 20.7415 18.0065C20.9167 17.7026 21.0089 17.358 21.0088 17.0072C21.0087 16.6564 20.9164 16.3119 20.741 16.0081Z",
    stroke: "#DC2626",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0146 7.01123V11.0098",
    stroke: "#DC2626",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0146 15.0083H11.0246",
    stroke: "#DC2626",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon3);
export default __webpack_public_path__ + "static/media/EmergencyIcon3.b6b048f2c29d4a4f6840e83bc15be778.svg";
export { ForwardRef as ReactComponent };